// Library is generally available. Keep the helper names so render paths and
// AuthContext do not need special-case cleanup.

/** AuthContext calls this whenever the signed-in email changes (incl. logout). */
export function syncLibraryAccessEmail(_email: string | null | undefined): void {
  void _email
  // No-op: library is available to every signed-in user.
}

/** Reactive read for render-path gates (nav tab, panels, context menus). */
export function useLibraryEnabled(): boolean {
  return true
}

/** Point-in-time read for event handlers and non-React modules. */
export function isLibraryEnabled(): boolean {
  return true
}
